import { render } from "./Login.vue?vue&type=template&id=a4983de6&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=a4983de6&lang=scss&scoped=true"

import exportComponent from "/home/irevors/CODING/ESTUDIOS/SENCE/ensayo prueba TD/ensayo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4983de6"]])

export default __exports__